export default __webpack_public_path__ + "static/media/IMG-20210701-WA00281.e14d8252.jpg";